import {Entity} from '@s-ui/domain'

export class ReservationEntity extends Entity {
  /**
   * @constructor
   * @param {String} reservationId
   * @param {String} id
   * @param {String} tenant
   * @param {String} createdAt
   * @param {String} externalRedirectUri
   * @param {String} modifiedAt
   * @param {String} adId
   * @param {String} buyerId
   * @param {String} buyerName
   * @param {String} buyerLastName
   * @param {String} email
   * @param {String} phone
   * @param {String} zipCode
   * @param {String} externalReference
   * @param {String} status
   * @param {String} conversationId
   * @param {String} rejectionReason
   * @param {String} appointmentMessage
   */
  static createFromApiCreateResponse({id}) {
    return new ReservationEntity({id})
  }

  static createFromPrimitives({id}) {
    return new ReservationEntity({id})
  }

  getId() {
    return this._id
  }
}
